import classNames from "classnames";
import { ReactComponent as WisdomAIButtonIcon } from "shared/assets/Icons/wisdom-ai-button.svg";
import { t } from "i18next";
import { EventNames } from "core/monitoring/types/enums";
import { trackEvents } from "core/monitoring/Events";
import { useWisdomAIEntry } from "../../../Views/WisdomAI/hooks/useWisdomAIEntry";

export const WisdomAINavButton = ({ className }: { className?: string }) => {
  const { enterWisdomAI, comingSoon } = useWisdomAIEntry();

  return (
    <>
      <button
        type="button"
        className={classNames(
          "flex rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple focus-visible:ring-offset-2",
          className
        )}
        aria-label={t("navigation.wisdomAINavigationLabel")}
        onClick={() => {
          trackEvents(EventNames.WISDOM_AI_NAV_CLICK);
          enterWisdomAI();
        }}
      >
        <WisdomAIButtonIcon aria-hidden="true" focusable="false" />
      </button>
      {comingSoon}
    </>
  );
};
